export const countDrawErrors = (drawObj: any, selectedBankDetails: any) => {
  let loanerrorCount = 0;
  const { drawAmountDetails } = drawObj;
  const fieldsToIgnore = [
    "drawId", // drawId comes from route (URL), not always on draw object from API
    "drawAmountDetails",
    "balanceToFinish",
    "originatorId",
    "propertyDetailsOptions",
    "drawType",
    "loanStatus",
    "finalApproval",
    "finalApprovalNotRequired",
    "originalMaturityDate", // todo:remove these below fields later
    "maturityDate",
    "currentMaturityDate",
    "nextPaymentDueDate",
    "gracePeriod",
    "payOffRequestDate",
    "availableFinancedBudgetAmount",
    "drawType",
    "loanExcelJson",
    "originatorName",
    "servicerId",
    "servicerName",
    "borrowerAddress",
    "requestedDate",
    "lastUpdatedDate",
    "documentTaggingStatus",
    "budgetReconcileStatus",
    "inspectionReviewStatus",
    "budgetReviewStatus",
    "prePurchaseDrawAmount",
    "brokerName",
    "originatingEntity",
    "sellerName",
    "fundingChannel"
  ];

  Object.keys(drawObj).forEach((field) => {
    if (fieldsToIgnore.includes(field)) return;

    // Special handling for propertyDetails: require at least one property selected.
    if (field === "propertyDetails") {
      const props = drawObj.propertyDetails;
      if (!Array.isArray(props) || props.length === 0) {
        console.error("field Error:", field);
        loanerrorCount++;
      }
      return;
    }

    if (!drawObj[field]) {
      console.error("field Error:", field);
      loanerrorCount++;
    }
  });

  Object.keys(drawAmountDetails).forEach((field) => {
    if (["edited", "stage", "comments"].includes(field)) return;
    let isZeroNetFunds = false;
    if (field === "netFundsToBorrower") {
      isZeroNetFunds = drawAmountDetails[field] === "0.00";
    }

    if (
      (!drawAmountDetails[field] && drawAmountDetails[field] !== 0) ||
      isZeroNetFunds
    ) {
      console.error("field Error:", field);
      loanerrorCount++;
    }
  });

  if (selectedBankDetails) {
    Object.keys(selectedBankDetails).forEach((field) => {
      if (
        [
          "netFundsToBorrower",
          "edited",
          "bankDetailId",
          "borrowerEntityName",
          "updatedBy"
        ].includes(field)
      )
        return;
      if (!selectedBankDetails[field]) {
        console.error("field Error:", field);
        loanerrorCount++;
      }
      if (field === "routing" && selectedBankDetails[field]?.length != 9) {
        console.error("field Error:", field);
        loanerrorCount++;
      }
    });
  } else {
    loanerrorCount += 4;
  }
  return loanerrorCount;
};